<template>
    <div>
        <main class="main-content">
            <div class="page-content">
                <div class="container-xl">
                    <section class="section-hotels-edit-rooms">
                        <div class="hotels-wrap">
                          <HotelsSideMenu />
                            <div class="hotels-content">
                                <div class="lds-ring" v-if="!isLoad">
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                    <div></div>
                                </div>
                                <div class="hotel-inner hotel-inner__camps" v-if="isLoad">
                                    <h1 class="hotel-inner__title">{{ hotelName }}</h1>
                                    <form>
                                        <h2>Mobile Camps</h2>
                                        <div class="form-control-group form-control-group_mob-camp">
                                            <div class="hotel-subtitle">MOBILE CAMP - LOCATIONS</div>
                                            <div v-for="(item, index) in camps" :key="index">
                                                <div class="line-5">
                                                    <div class="form-control-group form-control-group_5_1"><span
                                                        class="form-control-label">Territory</span>
                                                        <div
                                                            :class="['select-wrapper', {'is-active' : item.territory}, { 'is-error' : item.errors.area }]"
                                                            @click="openSelect('territory', index);item.errors.area = false">
                                                            <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                        item.data.territories.find(t => t.id === item.territoryId) ? item.data.territories.find(t => t.id === item.territoryId).names.EN : ''
                                    }}</span>
                                                                <span
                                                                    class="select-trigger__icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-chevron ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron">
                                                                        </use>
                                                                    </svg></span></div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div v-for="territory in item.data.territories"
                                                                         :key="territory.id"
                                                                         :class="['select-option', { 'is-selected' : item.territoryId === territory.id }]"
                                                                         @click="item.territoryId = territory.id;getLocations(territory.id, index);item.locationId = null; item.data.locations = [];item.areaId = null;item.data.areas = [];isEdit = true">
                                                                        <span class="select-option__name">{{
                                                                                territory.names.EN
                                                                            }}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        :class="['form-control-group form-control-group_5_1', { 'disabled' : !item.data.locations.length }]"><span
                                                        class="form-control-label">Location</span>
                                                        <div
                                                            :class="['select-wrapper', {'is-active' : item.location}, { 'is-error' : item.errors.area }]"
                                                            @click="openSelect('location', index);item.errors.area = false">
                                                            <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                        item.data.locations.find(t => t.id === item.locationId) ? item.data.locations.find(t => t.id === item.locationId).names.EN : ''
                                    }}</span>
                                                                <span
                                                                    class="select-trigger__icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-chevron ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron">
                                                                        </use>
                                                                    </svg></span></div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div v-for="location in item.data.locations"
                                                                         :key="location.id"
                                                                         :class="['select-option', { 'is-selected' : item.locationId === location.id }]"
                                                                         @click="item.locationId = location.id;getAreas(location.id, index);item.areaId = null;item.data.areas = [];isEdit = true">
                                                                        <span class="select-option__name">{{
                                                                                location.names.EN
                                                                            }}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        :class="['form-control-group form-control-group_5_1', { 'disabled' : !item.data.areas.length }]"><span
                                                        class="form-control-label">Area</span>
                                                        <div
                                                            :class="['select-wrapper', {'is-active' : item.area}, { 'is-error' : item.errors.area }]"
                                                            @click="openSelect('area', index);item.errors.area = false">
                                                            <div class="select-trigger">
                                <span class="select-trigger__name">{{
                                        item.data.areas.find(t => t.id === item.areaId) ? item.data.areas.find(t => t.id === item.areaId).names.EN : ''
                                    }}</span>
                                                                <span
                                                                    class="select-trigger__icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-chevron ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron">
                                                                        </use>
                                                                    </svg></span></div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div v-for="area in item.data.areas" :key="area.id"
                                                                         :class="['select-option', { 'is-selected' : item.areaId === area.id }]"
                                                                         @click="item.areaId = area.id;isEdit = true"><span
                                                                        class="select-option__name">{{
                                                                            area.names.EN
                                                                        }}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="line-5">

                                                    <div
                                                        class="form-control-datepicker form-control-datepicker--labeled">
                                                        <div class="form-control-group"><span
                                                            class="form-control-label">From</span>
                                                            <div
                                                                :class="['form-control-wrap', { 'is-error' : item.errors.from }]">
                                                                <input type="text" Placeholder="Date From"
                                                                       v-model="item.dateFrom"
                                                                       @focus="item.errors.from = false;isEdit = true"
                                                                       @blur="item.dateFrom = $event.target.value"
                                                                       class="form-control js-datepicker-single">
                                                                <div class="form-control-icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-calendar ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar">
                                                                        </use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="form-control-group"><span
                                                            class="form-control-label">To</span>
                                                            <div
                                                                :class="['form-control-wrap', { 'is-error' : item.errors.to }]">
                                                                <input type="text" Placeholder="Date To"
                                                                       class="form-control js-datepicker-single"
                                                                       @focus="item.errors.to = false;isEdit = true"
                                                                       v-model="item.dateTo"
                                                                       @blur="item.dateTo = $event.target.value">
                                                                <div class="form-control-icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-calendar ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-calendar">
                                                                        </use>
                                                                    </svg>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <button type="button" class="btn btn--remove" @click="$emit('deleteModalHandler', {
                                                            entity: 'Camp',
                                                            name: 'this',
                                                            handler: removeCamp,
                                                            id: index
                                                        })">
                                                        <svg width="1em" height="1em" class="icon icon-close ">
                                                            <use
                                                                xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close">
                                                            </use>
                                                        </svg>
                                                    </button>
                                                </div>
                                                <div class="line-cols line-6">
                                                    <div class="form-control-group"><span class="form-control-label">Closest
                                                            Airport /
                                                            Airstrip</span>
                                                        <div
                                                            :class="['select-wrapper', {'is-active' : item.airport}, { 'is-error' : item.errors.airstrip }]"
                                                            @click="openSelect('airport', index);item.errors.airstrip = false">
                                                            <div class="select-trigger"><span
                                                                class="select-trigger__name">{{
                                                                    data.airstrips.find(t => t.id === item.airstripId) ? data.airstrips.find(t => t.id === item.airstripId).title : ''
                                                                }}</span><span class="select-trigger__icon">
                                                                    <svg width="1em" height="1em"
                                                                         class="icon icon-chevron ">
                                                                        <use
                                                                            xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-chevron">
                                                                        </use>
                                                                    </svg></span></div>
                                                            <div class="select-body">
                                                                <div class="select-inner">
                                                                    <div v-for="(airstrip, index) in data.airstrips"
                                                                         :key="index"
                                                                         :class="['select-option', { 'is-selected' : item.airstripId === airstrip.id }]"
                                                                         @click="item.airstripId = airstrip.id;isEdit = true"><span
                                                                        class="select-option__name">{{
                                                                            airstrip.title
                                                                        }}</span></div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div
                                                        class="form-control-group form-control-group--time form-control-group--time_half is-active">
                                                        <span class="form-control-label">Transfer Time (min)</span>
                                                        <div
                                                            :class="['form-control-wrap', { 'is-error' : item.errors.min }]">
                                                            <input type="text" v-model="item.transferTimeMin"
                                                                   @focus="item.errors.min = false;isEdit = true"
                                                                   class="form-control">
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="hr"></div>
                                            </div>
                                            <div class="line-add-mob-camp">
                                                <button type="button" class="btn btn--rounded2 btn--green"
                                                        @click="addCamp();isEdit = true"> <span>Add
                                                        Mobile
                                                        Camp</span></button>
                                            </div>
                                        </div>
                                        <div class="edit-rooms__btn-edit">
                                            <button type="button" class="btn btn--green" @click="updatePopup = true">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="modal-wrapper" v-if="updatePopup">
                            <div class="modal-backdrop"></div>
                            <div class="modal-inner">
                                <div class="edit-popup edit-popup--history">
                                    <div class="edit-popup__header">
                                        <div class="edit-popup__title">
                                            Update History
                                        </div>
                                        <div class="edit-popup__close" @click="updatePopup = false">
                                            <svg width="1em" height="1em" class="icon icon-close ">
                                                <use
                                                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
                                            </svg>
                                        </div>
                                    </div>
                                    <form action="javascript:void(0)" class="edit-popup__inner">
                                        <div class="form-control-group"><span
                                            class="form-control-label">Hi {{ user ? user.data.firstName : '' }}, <span> what have you updated?</span> </span>
                                            <div class="form-control-wrap">
                                                <textarea class="form-control" v-model="descriptionUpdate">Rates, Hotel Description</textarea>
                                            </div>
                                          <div class="edit-popup__error-text">
                                            <span v-if="descriptionUpdate.length < 6">Minimum 6 symbols are required</span>
                                          </div>
                                        </div>
                                        <div class="options-additional__btns">
                                            <button type="button" class="btn btn--silver" @click="updatePopup = false">
                                                <span>Cancel</span>
                                            </button>
                                            <button type="submit" class="btn btn--green edit-popup__submit"
                                                    :disabled="descriptionUpdate.length < 6"
                                                    @click="updateCamps">
                                                <span>Update</span>
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </main>
    </div>
</template>

<script>
import {
    API,
    getTerritoriesAll,
    getLocationsTerritoriesAll,
    getAreasLocaitonAll,
    getPointsAll,
    getHotelsCamps,
    updateHotelsCamps,
    getHotelAdvanced
} from '@/utilites/api'

import {
    date
} from '@/utilites/functions'

import Lightpick from 'lightpick'
import HotelsSideMenu from '@/components/HotelsSideMenu/HotelsSideMenu.vue'

export default {
    data() {
        return {
            camps: [],
            isLoad: false,
            updatePopup: false,
            descriptionUpdate: '',
            isEdit: false,
            data: {
                airstrips: [],
                areas: [],
                territories: []
            },
            hotelName: ''
        }
    },
    components: {HotelsSideMenu, Lightpick},
    props: ['user'],
    beforeRouteLeave(to, from, next) {
        if (this.isEdit) {
            this.$emit('notLeaveHandler')
        }
        next()
    },
    created() {
        getHotelAdvanced(this.$route.params.id)
            .then(res => {
                this.hotelName = res.names.EN
            })
    },
    methods: {
        checkErrorCamps() {
            let error = false
            this.camps = this.camps.map(item => {
                if (!item.areaId || !item.airstripId || !item.dateFrom || !item.dateTo || !item.transferTimeMin) {
                    error = true
                    return ({
                        ...item,
                        errors: {
                            area: !item.areaId,
                            airstrip: !item.airstripId,
                            from: !item.dateFrom,
                            to: !item.dateTo,
                            min: !item.transferTimeMin
                        }
                    })
                }
                return item
            })
            return error
        },
        openSelect(name, index) {
            this.camps = this.camps.map((item, i) => index === i ? ({
                ...item,
                area: false,
                territory: false,
                location: false,
                airport: false,
                [name]: !item[name]
            }) : ({...item, area: false, airport: false, territory: false, location: false}))
        },
        updateDatePickers() {
            document.querySelectorAll('.lightpick').forEach(elem => {
                elem.remove()
            })
            setTimeout(() => {
                document.querySelectorAll('.js-datepicker-single').forEach(item => {
                    const datePicker = new Lightpick({
                        field: item,
                        singleDate: true,
                        lang: 'en',
                        format: 'DD MMM YYYY',
                        onClose: function () {
                            item.blur()
                        },
                        onSelect: function () {
                            item.focus()
                            item.blur()
                        }
                    });
                    item.addEventListener('blur', () => {
                      datePicker.hide()
                    })
                });
            }, 1000)
        },
        addCamp() {
            this.camps = this.camps.concat({
                hotelId: this.$route.params.id,
                dateFrom: '',
                dateTo: '',
                transferTimeMin: '',
                airstripId: null,
                areaId: null,
                territoryId: null,
                locationId: null,
                area: false,
                territory: false,
                location: false,
                airport: false,
                errors: {},
                data: {
                    territories: this.data.territories,
                    locations: [],
                    areas: []
                }
            })
            this.updateDatePickers()
        },
        removeCamp(index) {
            this.camps = this.camps.filter((item, i) => !(i === index))
            this.isEdit = true
        },
        updateCamps() {
            if (!this.checkErrorCamps()) {
                updateHotelsCamps({
                    "camps": this.camps.map(item => ({
                        "id": item.id,
                        "hotelId": +item.hotelId,
                        "areaId": item.areaId,
                        "airstripId": item.airstripId,
                        "dateFrom": date(item.dateFrom, 'start'),
                        "dateTo": date(item.dateTo, 'start'),
                        "transferTimeMin": +item.transferTimeMin
                    })),
                    history: {
                        hotelId: +this.$route.params.id,
                        userId: this.user.data.id,
                        description: this.descriptionUpdate
                    }
                }, this.$route.params.id)
                    .then(res => {
                        this.isEdit = false
                        this.$emit('confirmed')
                        this.descriptionUpdate = ''
                        this.updatePopup = false
                    })
            } else {
                this.descriptionUpdate = ''
                this.updatePopup = false
            }
        },
        getLocations(id, index) {
            getLocationsTerritoriesAll('', id)
                .then(res => {
                    this.camps = this.camps.map((item, i) => i === index ? ({
                        ...item,
                        data: {
                            ...item.data,
                            locations: res.sort((a, b) => a.names.EN > b.names.EN ? 1 : -1)
                        }
                    }) : item)
                })
        },
        getAreas(id, index) {
            getAreasLocaitonAll('', id)
                .then(res => {
                    this.camps = this.camps.map((item, i) => i === index ? ({
                        ...item,
                        data: {
                            ...item.data,
                            areas: res
                        }
                    }) : item)
                })
        },

        waitSaveTiming() {
            const saveFun = () => {
                this.updatePopup = true;
            }
            const waitFun = () => {
                this.waitSaveTiming();
            }
            setTimeout(() => {
                this.$emit('waitSaveHandler', [saveFun, waitFun]);
            }, 10 * 60 * 1000)
        },
    },
    mounted() {
        window.addEventListener('click', event => {
            if (!event.target.closest('.select-wrapper')) {
                this.openSelect()
            }
        })
        this.updateDatePickers()
        const id = this.$route.params.id
        Promise.all([getTerritoriesAll(), getPointsAll(), getHotelsCamps(id)])
            .then(res => {
                let airports = res[1].filter(item => item.type === 'AIRPORT')
                let airstrips = res[1].filter(item => item.type === 'AIRSTRIP')
                this.data.territories = res[0]
                this.data.airstrips = airports.sort((a, b) => a.title > b.title ? 1 : -1).concat(airstrips.sort((a, b) => a.title > b.title ? 1 : -1)).map((item) => ({
                    ...item,
                    active: false
                }))
                this.camps = res[2].map(item => ({
                    errors: {},
                    hotelId: this.$route.params.id,
                    dateFrom: date(item.dateFrom, 'fromStart'),
                    dateTo: date(item.dateTo, 'fromStart'),
                    transferTimeMin: item.transferTimeMin,
                    airstripId: item.airstripId,
                    areaId: item.areaId,
                    territoryId: null,
                    locationId: null,
                    area: false,
                    territory: false,
                    location: false,
                    airport: false,
                    data: {
                        territories: this.data.territories,
                        locations: [],
                        areas: []
                    }
                }))
                this.isLoad = true
            })
    },
    watch: {
        isEdit(val) {
            if (val) this.waitSaveTiming();
        },
    },
}
</script>
